/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_IntensityInputs */

const en_ui_more_stats_intensity = /** @type {(inputs: Ui_More_Stats_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensity`)
};

const de_ui_more_stats_intensity = /** @type {(inputs: Ui_More_Stats_IntensityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intensität`)
};

/**
* | output |
* | --- |
* | "Intensity" |
*
* @param {Ui_More_Stats_IntensityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_intensity = /** @type {((inputs?: Ui_More_Stats_IntensityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_IntensityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_intensity(inputs)
	return de_ui_more_stats_intensity(inputs)
});